var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHbr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 18.3131C0 9.27256 6.36031 1.73145 14.8107 1.88141e-05V5.94545C10.0537 7.39447 6.46549 11.5632 5.8205 16.6603H11.5356C12.3542 13.5713 15.169 11.2946 18.5155 11.2946C21.862 11.2946 24.6768 13.5713 25.4953 16.6603H31.2064C30.5614 11.5631 26.9731 7.39442 22.2161 5.94542V0C30.6665 1.7314 37.0269 9.27252 37.0269 18.3131C37.0269 28.6336 28.7381 37 18.5135 37C8.28875 37 0 28.6336 0 18.3131ZM31.1499 20.363H25.497C24.8364 22.8654 22.866 24.8357 20.3637 25.4964V31.0957C25.8899 30.2879 30.2727 25.9155 31.1499 20.363ZM16.661 31.0954V25.4947C14.1616 24.8324 12.1941 22.8633 11.5339 20.363H5.87698C6.75404 25.9148 11.1358 30.2867 16.661 31.0954Z",
    fill: "#FFC93E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHbr);
export default __webpack_public_path__ + "static/media/hbr.c44fa377887eca52be93f23ab61f6b99.svg";
export { ForwardRef as ReactComponent };